import * as React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import './centum-tree.css';

export interface ITreeAPC_branch {
    type: 'file' | 'folder';
    iconUrl?: string;
    id?: string;
    name: string;
    class?: string;
    path: string;
    title?: string;
    pointer?: boolean;
    active?: boolean;
    clickCallBack?: Function;
    contextCallBack?: (ev: React.MouseEvent) => void;
    children?: ITreeAPC_branch[];
    editNameCallBack?: Function;
    editModeEnbl?: boolean;
    editModeErrCB?: Function;
}
interface IPropsTreeAPC {
    inpArr: ITreeAPC_branch[];
    selectedLeaf: (name: string, path: string) => void;
}

interface IStateTreeAPC {
    selectBranch?: ITreeAPC_branch;
}

const TreeAPC: React.FC<IPropsTreeAPC> = React.memo(({ inpArr, selectedLeaf }) => {
    const [selectBranch, setSelectBranch] = useState<ITreeAPC_branch | undefined>(undefined);

    const handleSelectBranch = useCallback((branch: ITreeAPC_branch) => {
        setSelectBranch(branch);
    }, []);

    const createBranchTree = useCallback(
        (branch: ITreeAPC_branch, ind: number, pbranch: ITreeAPC_branch | undefined = undefined) => {
            if (branch.path !== undefined) {
                let parts = branch.path.split('/');
                if (parts[0] === 'MNEMONICDIAGRAMFOLDER') {
                    parts[0] = 'USER';
                    branch.path = parts.join('/');
                }
            }

            const selection = selectBranch != null ? selectBranch.path === branch.path : false;

            if (branch.type === 'file') {
                return (
                    <Leaf
                        key={branch.name + ind}
                        name={branch.name}
                        path={branch.path}
                        clickCB={() => {
                            handleSelectBranch(branch);
                            if (branch.clickCallBack) branch.clickCallBack();
                        }}
                        iconUrl={branch.iconUrl}
                        contextCB={(ev: React.MouseEvent) => {
                            handleSelectBranch(branch);
                            if (branch.contextCallBack) branch.contextCallBack(ev);
                        }}
                        editNameCallBack={branch.editNameCallBack}
                        selection={selection}
                        editModeEnbl={branch.editModeEnbl}
                        editModeErrCB={branch.editModeErrCB}
                        selectedLeaf={selectedLeaf}
                    />
                );
            } else if (branch.type === 'folder') {
                return (
                    <Branch
                        key={branch.name + ind}
                        name={branch.name}
                        path={branch.path}
                        iconUrl={branch.iconUrl}
                        clickCB={() => {
                            handleSelectBranch(branch);
                            if (branch.clickCallBack) branch.clickCallBack();
                        }}
                        contextCB={(ev: React.MouseEvent) => {
                            handleSelectBranch(branch);
                            if (branch.contextCallBack) branch.contextCallBack(ev);
                        }}
                        pointer={branch.pointer}
                        editNameCallBack={branch.editNameCallBack}
                        selection={selection}
                        editModeEnbl={branch.editModeEnbl}
                        editModeErrCB={branch.editModeErrCB}
                        selectedLeaf={selectedLeaf}>
                        {branch.children?.map((brn: any, ind: any) => createBranchTree(brn, ind, branch))}
                    </Branch>
                );
            }

            return null;
        },
        [selectBranch, handleSelectBranch, selectedLeaf]
    );

    return <div style={{ width: '100%', height: '100%' }}>{inpArr.map((inp, ind) => createBranchTree(inp, ind))}</div>;
});

export default TreeAPC;

interface IPropsBranch {
    name: string;
    path: string;
    iconUrl?: string;
    clickCB?: Function;
    contextCB?: Function;
    pointer?: boolean;
    editNameCallBack?: Function;
    selection?: boolean;
    editModeEnbl?: boolean;
    editModeErrCB?: Function;
    children?: any;
    selectedLeaf?: (name: string, path: string) => void;
}

const Branch: React.FC<IPropsBranch> = ({
    name,
    path,
    iconUrl = 'static/images/folder.svg',
    children,
    clickCB,
    pointer,
    contextCB,
    editNameCallBack,
    selection = false,
    editModeEnbl = false,
    editModeErrCB,
    selectedLeaf
}) => {
    const row: any = useRef(null);

    const [stateBranch, setStateBranch] = React.useState(false);
    const [editMod, setEditMode] = useState(false);

    useEffect(() => {
        if (row.current.parentNode.style.display !== 'none' && editModeEnbl) {
            setEditMode(true);
        } else if (row.current.parentNode.style.display !== 'none' && !editModeEnbl) {
        } else {
            editModeErrCB && editModeErrCB();
        }
    }, [editModeEnbl]);

    return (
        <div ref={row}>
            <div style={{ display: 'flex', alignItems: 'center', height: '1.2em', userSelect: 'none' }}>
                <div
                    onClick={() => {
                        setStateBranch(!stateBranch);
                    }}
                    style={{
                        minWidth: '0.9em',
                        height: '0.9em',
                        color: '#A1A1A1',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '0 0.25em',
                        cursor: 'pointer'
                    }}>
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: 'pointer' }}>
                        {stateBranch ? (
                            <polygon points="7 10 11 4 3 4" stroke="#a0a4a8" strokeWidth="1" fill="white" />
                        ) : (
                            <polygon points="4 3 10 7 4 11" stroke="#7d858d" strokeWidth="1" fill="#7d858d" />
                        )}
                    </svg>
                </div>
                <div
                    onClick={() => {
                        clickCB !== undefined && clickCB();
                    }}
                    style={{ display: 'flex', alignItems: 'center', height: '2em', userSelect: 'none' }}
                    onMouseOver={() => {
                        selectedLeaf !== undefined && selectedLeaf(name, path);
                    }}
                    onContextMenu={(e) => {
                        contextCB !== undefined && contextCB(e);
                    }}
                    onDoubleClick={() => {
                        editNameCallBack !== undefined && setEditMode(true);
                    }}>
                    <div style={{ height: '1em', width: '1em', margin: '0 0.25em' }}>
                        <img style={{ height: '100%', width: '100%' }} src={iconUrl} />
                    </div>
                    <div style={{ margin: '0 0.25em', cursor: pointer ? 'pointer' : '' }}>
                        {editMod ? (
                            <input
                                autoFocus
                                style={{ fontSize: '1em', color: '#686868', whiteSpace: 'nowrap' }}
                                defaultValue={name}
                                onBlur={(e) => {
                                    editNameCallBack !== undefined && editNameCallBack(e.target.value);
                                    setEditMode(false);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        editNameCallBack !== undefined && editNameCallBack(e.currentTarget.value);
                                        setEditMode(false);
                                    }
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    fontSize: '0.8em',
                                    fontFamily: 'Roboto',
                                    color: '#686868',
                                    whiteSpace: 'nowrap',
                                    fontWeight: selection ? '500' : 400
                                }}>
                                {name}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div
                style={{
                    minWidth: '10em',
                    display: stateBranch ? '' : 'none',
                    opacity: stateBranch ? 1 : 0,
                    maxHeight: stateBranch ? 'max-content' : '0',
                    paddingLeft: '22px'
                }}>
                {children}
            </div>
        </div>
    );
};

interface IPropsLeaf {
    name: string;
    path: string;
    active?: boolean;
    iconUrl?: string;
    clickCB?: Function;
    contextCB?: Function;
    pointer?: boolean;
    editNameCallBack?: Function;
    selection?: boolean;
    editModeEnbl?: boolean;
    editModeErrCB?: Function;
    selectedLeaf?: (name: string, path: string) => void;
}
const Leaf: React.FC<IPropsLeaf> = ({
    name,
    iconUrl = 'static/images/image_mini.svg',
    path,
    clickCB,
    pointer,
    contextCB,
    editNameCallBack,
    selection = false,
    editModeEnbl = false,
    editModeErrCB,
    selectedLeaf
}) => {
    const row: any = useRef(null);

    const [editMod, setEditMode] = useState(false);

    useEffect(() => {
        if (row.current.parentNode.style.display !== 'none' && editModeEnbl) {
            setEditMode(true);
        } else if (row.current.parentNode.style.display !== 'none' && !editModeEnbl) {
        } else {
            editModeErrCB && editModeErrCB();
        }
    }, [editModeEnbl]);

    return (
        <div
            ref={row}
            onClick={() => {
                clickCB !== undefined && clickCB();
            }}
            onMouseOver={() => {
                selectedLeaf !== undefined && selectedLeaf(name, path);
            }}
            onContextMenu={(e) => {
                contextCB !== undefined && contextCB(e);
            }}
            onDoubleClick={() => {
                editNameCallBack !== undefined && setEditMode(true);
            }}
            style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                height: '1.2em',
                userSelect: 'none',
                paddingLeft: '22px'
            }}>
            <div style={{ minWidth: '16px', height: '1em', width: '1em', margin: '0 0.25em' }}>
                <img style={{ height: '100%', width: '100%' }} src={iconUrl} />
            </div>
            <div style={{ margin: '0 0.25em' }}>
                {editMod ? (
                    <input
                        autoFocus
                        style={{ fontSize: '1em', color: '#686868', whiteSpace: 'nowrap' }}
                        defaultValue={name}
                        onBlur={(e) => {
                            editNameCallBack !== undefined && editNameCallBack(e.target.value);
                            setEditMode(false);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                editNameCallBack !== undefined && editNameCallBack(e.currentTarget.value);
                                setEditMode(false);
                            }
                        }}
                    />
                ) : (
                    <div
                        style={{
                            fontSize: '0.8em',
                            color: '#686868',
                            whiteSpace: 'nowrap',
                            fontWeight: selection ? '500' : 400
                        }}>
                        {name}
                    </div>
                )}
            </div>
        </div>
    );
};
